import React from 'react';
import { ReactComponent as PaperclipIcon } from '../../../../icons/paperclip.svg';

type AttachmentItemProps = {
  attachment: any;
  index: number;
  onAttachmentClick: (attachmentId: string, filename?: string) => void;
};

const AttachmentItem: React.FC<AttachmentItemProps> = ({
  attachment,
  index,
  onAttachmentClick,
}) => {
  if (typeof attachment === 'string') {
    return (
      <div
        className='attachment-item'
        onClick={() => window.open(attachment, '_blank', 'noopener,noreferrer')}
      >
        <PaperclipIcon />
        <div className='attachment-text'>
          <span>Attachment</span>
          <span className='filename'>Attachment {index + 1}</span>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className='attachment-item'
        onClick={(e) => {
          e.preventDefault();
          onAttachmentClick(attachment.id, attachment.filename);
        }}
      >
        <PaperclipIcon />
        <div className='attachment-text'>
          <span>Attachment</span>
          <span className='filename'>{attachment.filename}</span>
        </div>
      </div>
    );
  }
};

export default AttachmentItem;
